export default {
  to: "/myapplications",
  order: 2,
  icon: "mdi-sort-variant",
  title: "Applications",
  disabled: false,
  value: 0,
};
